import { render, staticRenderFns } from "./PrometCreate.vue?vue&type=template&id=8f3686ca&scoped=true&"
import script from "./PrometCreate.vue?vue&type=script&lang=js&"
export * from "./PrometCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3686ca",
  null
  
)

export default component.exports